var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBannerIllustration = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 102,
    viewBox: "0 0 108 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5535 81.4717C31.9857 81.4717 34.7681 79.8817 34.7681 77.9205V73.1855H22.3389V77.9205C22.3389 79.8817 25.1212 81.4717 28.5535 81.4717Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5535,
    cy: 72.997,
    rx: 6.2146,
    ry: 3.5781,
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8447 71.2839V48.001L32.8841 50.022V71.2839C32.8841 72.2944 31.7994 74.3154 28.4936 74.3154C25.1877 74.3154 24.103 72.2944 23.8447 71.2839Z",
    fill: "#F8F9FF",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7176 2.51709L20.3687 5.10102L8.48253 27.3228L2.79801 23.7053C1.9367 22.2411 1.04094 17.6589 4.34836 11.044C7.65579 4.4292 13.306 2.60322 15.7176 2.51709Z",
    fill: "#F1F3FF",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8731 2L50.0839 13.3693L31.3784 51.1518L9.25784 39.4669C7.79361 36.6246 6.00209 28.201 10.5498 17.2452C15.0975 6.28932 24.6527 2.68905 28.8731 2Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6723 15.6718C52.9293 16.992 54.4197 19.8582 54.5224 24.041C54.6241 28.181 53.3218 33.227 50.4637 38.1134C47.6056 42.9997 43.8458 46.6083 40.1874 48.549C36.4913 50.5098 33.2625 50.6158 31.0054 49.2956C28.7486 47.9754 27.2589 45.1094 27.1562 40.9269C27.0545 36.7869 28.3568 31.7409 31.2148 26.8545C34.073 21.9681 37.8328 18.3596 41.4912 16.4189C45.1871 14.4582 48.4153 14.3518 50.6723 15.6718Z",
    stroke: "#040222",
    strokeWidth: 4.68289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0234 20.3459C63.1064 21.9996 53.9593 17.5897 51.3754 15.1781C32.4899 12.0772 20.8624 42.5675 31.7375 50.5779C42.5898 54.6475 45.0652 63.7559 46.1849 67.6318C47.7353 65.3062 55.8714 51.353 79.0234 20.3459Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0143 17.6083C101.873 20.6234 105.674 26.6679 106.185 34.3786C106.702 42.1767 103.839 51.7031 98.1806 61.3767C92.5913 70.9325 83.3453 78.4805 74.4792 82.8364C70.0492 85.0128 65.7627 86.3676 62.1267 86.7947C58.5675 87.2127 55.815 86.7239 54.0974 85.4719L53.9344 85.3483C49.9029 82.1707 47.1127 75.8787 46.7856 67.8238C46.4601 59.8072 48.5897 50.1903 54.21 40.5814C59.8355 30.9636 67.1635 24.1725 74.4175 20.3195C81.4699 16.5735 88.3373 15.656 93.5181 17.4278L94.0143 17.6083Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9794 21.9378C104.83 24.7752 107.143 31.1146 106.803 39.2641C106.463 47.3902 103.481 57.1843 97.9143 66.7022C92.3472 76.2199 85.2725 83.6193 78.3561 87.8984C71.4198 92.1899 64.7602 93.2811 59.9095 90.4439C55.0587 87.6067 52.7447 81.2668 53.0852 73.1172C53.4248 64.9912 56.4072 55.1981 61.9741 45.6804C67.5411 36.1626 74.6155 28.7621 81.5319 24.4829C88.4683 20.1913 95.1286 19.1006 99.9794 21.9378Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.936578,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2101 21.8064C99.4077 24.2618 101.534 29.8887 101.18 37.4809C100.829 45.0131 98.0286 54.1558 92.8079 63.0814C87.5872 72.007 80.9912 78.9296 74.598 82.928C68.154 86.9581 62.207 87.8625 58.0093 85.4074C53.8115 82.9521 51.685 77.3252 52.0389 69.7329C52.3901 62.2006 55.1899 53.0575 60.4106 44.1319C65.6313 35.2063 72.2282 28.2841 78.6213 24.2858C85.0654 20.2558 91.0124 19.3511 95.2101 21.8064Z",
    fill: "#FAFAFB",
    stroke: "#040222",
    strokeWidth: 2.26056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3269 31.0351C77.2342 35.4739 79.4443 44.6204 75.2296 51.7467C71.0298 58.8475 62.0003 61.3228 54.7957 57.4671C55.5225 54.1808 57.0869 49.2118 59.5905 44.2691C62.1841 39.1489 65.7385 34.1482 70.3269 31.0351Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.87316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1244 22.8282C100.919 25.048 103.474 30.1556 103.431 37.9934C103.389 45.703 100.766 55.1789 95.3502 64.4377C89.9348 73.6962 82.9616 80.627 76.2625 84.4428C69.4517 88.3221 63.7473 88.6 59.9522 86.3803C56.1571 84.1605 53.6032 79.0523 53.646 71.2142C53.6881 63.5046 56.311 54.0294 61.7264 44.7708C67.142 35.512 74.1154 28.5806 80.8147 24.7648C87.6254 20.8856 93.3294 20.6085 97.1244 22.8282Z",
    stroke: "#040222",
    strokeWidth: 8.45827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBannerIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bannerIllustration.cc58b20773e8d9a2dcb2f4cb66d92ac7.svg";